import styles from '../../../styles/ocorrencia/ConsultarOcorrenciaForm.module.scss'
import { Field, FormRenderProps } from '@progress/kendo-react-form'
import { Checkbox, TextArea, RadioButton, RadioGroup, Input } from '@progress/kendo-react-inputs'
import { useEffect, useState } from 'react'
import { ADOTADA, DEZATECEM, MAIORQUECEM, NAO, NAO_SABE, POR_ADOTAR, SIM, UMATEDEZ } from '../../../utils/constants'
import clsx from 'clsx'
import { opacity } from 'html2canvas/dist/types/css/property-descriptors/opacity'
import { useOcorrenciaStore } from '../../../stores/ocorrencias'

type IProps = {
  formRenderProps?: FormRenderProps
  viewMode?: boolean
  tipologiaValidator?: boolean

  onCheckboxChangeInstabilidade?: any
  onCheckboxChangeErosao?: any
  onCheckboxChangeGalmento?: any
  onCheckboxChangeProtecao?: any
  isMobile?: boolean
}
export function OcorrenciaTerrenoDetalhe({ formRenderProps, viewMode, tipologiaValidator, onCheckboxChangeInstabilidade, onCheckboxChangeErosao, onCheckboxChangeGalmento, onCheckboxChangeProtecao, isMobile }: IProps) {
  const [danosSelection, setDanosSelection] = useState(NAO);

  const handleDanosChange = (e : any) => {
    setDanosSelection(e.value);
  };
  const keyPressTextArea = (e: any) => {
    if (viewMode) {
      e.preventDefault();
      return false;
    }
  }

  const selectedOcorrenciaResult: any = useOcorrenciaStore(
    (state) => state.selectedOcorrenciaResult
  )

 
  const [pessoaEmRisco, setPessoaEmRisco] = useState(undefined);

  const handlePessoaEmRiscoChange = (event: any) => {
    setPessoaEmRisco(event.value);
  };

  return (
    <div className={`${styles.form} ${styles.removeScrollDuplicado}`}>

      <fieldset>
        <legend>
          <span className={styles.fieldsetTitulo}>Tipologia da ocorrência*</span>
        </legend>

        <div className={`${styles.espacoVerticalFieldSet} ${tipologiaValidator && !viewMode ? 'ValidatorMultiplaCheck' : ''}`}>

          <div className={styles.firstPontosDetalhes}>
            <Field
              name="instabiladeArribas"
              label="Instabilidade em arribas"
              component={Checkbox}
              onChange={onCheckboxChangeInstabilidade}
              disabled={viewMode}
            />
            {formRenderProps?.valueGetter("instabiladeArribas") ? (

              <div className={clsx(styles.subitem, styles.subPontosDetalhes)}>
                <div className={styles.spacingPontos}>
                  <Field
                    name="movimentoMassa"
                    label="Movimento de massa de vertente (MMV)"
                    component={Checkbox}
                    disabled={viewMode}
                  />
                </div>

                {formRenderProps?.valueGetter("movimentoMassa") ? (
                  isMobile ?
                  <div className={styles.spacingPontos}>
                    <label>Alcance máximo do depósito/detritos (m)</label>
                    <Field
                      name="tip_mmv_alcance_deposito"
                      component={Input}
                      maxLength={25}
                      type={'number'}
                      onKeyDown={(evt: any) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                      disabled={viewMode}
                      />
                  </div>
                  :
                  <div className={styles.spacingPontos}>
                    <Field
                      name="tip_mmv_alcance_deposito"
                      label="Alcance máximo do depósito/detritos (m)"
                      component={Input}
                      maxLength={25}
                      type={'number'}
                      onKeyDown={(evt: any) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                      disabled={viewMode}
                      />
                  </div>
                ) : null}

                <div className={styles.spacingPontos}>
                  <Field
                    name="fendaTracao"
                    label="Fenda de tração com abertura visível"
                    component={Checkbox}
                    disabled={viewMode}
                  />
                </div>
              </div>
            ) : null}
          </div>

          <div className={styles.outrosPontosDetalhes}>
            <Field
              name="erosaoRecuo"
              label="Erosão/recuo da linha de costa"
              component={Checkbox}
              onChange={onCheckboxChangeErosao}
              disabled={viewMode}
            />
            {formRenderProps?.valueGetter("erosaoRecuo") ? (
              <div className={clsx(styles.subitem, styles.subPontosDetalhes)}>
                <div className={styles.spacingPontos}>
                  <Field
                    name="escarpamento"
                    label="Escarpamento da duna"
                    component={Checkbox}
                    disabled={viewMode}
                  />
                </div>
                  {formRenderProps?.valueGetter("escarpamento") ? (
                    isMobile ? 
                    <div>
                      <label>Altura máxima da escarpa (m)</label>
                      <Field
                        name="tip_altura_maxima_escarpa"
                        component={Input}
                        maxLength={25}
                        disabled={viewMode} 
                        type={'number'}
                        onKeyDown={(evt: any) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                      />
                    </div>
                    :
                    <div>
                      <Field
                        name="tip_altura_maxima_escarpa"
                        label="Altura máxima da escarpa (m)"
                        component={Input}
                        maxLength={25}
                        disabled={viewMode} 
                        type={'number'}
                        onKeyDown={(evt: any) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                      />
                    </div>
                  ) : null}

                  <div className={styles.spacingPontos}>
                    <Field
                      name="rebaixamento"
                      label="Rebaixamento da praia"
                      component={Checkbox}
                      disabled={viewMode}
                    />
                  </div>
                  {formRenderProps?.valueGetter("rebaixamento") ? (
                    isMobile ?
                    <div>
                      <label>Altura máxima do rebaixamento da praia (m)</label>
                      <Field
                        name="tip_reb_praia_altura_max"
                        component={Input}
                        maxLength={25}
                        disabled={viewMode}
                        type={'number'}
                        onKeyDown={(evt: any) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                      />
                    </div>
                    :
                    <div>
                      <Field
                        name="tip_reb_praia_altura_max"
                        label="Altura máxima do rebaixamento da praia (m)"
                        component={Input}
                        maxLength={25}
                        disabled={viewMode}
                        type={'number'}
                        onKeyDown={(evt: any) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                      />
                    </div>
                  ) : null}
              </div>
            ) : null}
          </div>

          <div className={styles.outrosPontosDetalhes}>
            <Field
              name="galgamento"
              label="Galgamento costeiro"
              component={Checkbox}
              onChange={onCheckboxChangeGalmento}
              disabled={viewMode}
            />
            {formRenderProps?.valueGetter("galgamento") ? (
              isMobile ?
              <div className={clsx(styles.subitem, styles.subPontosDetalhes)}> 
                <div className={styles.spacingPontos}>
                  <label>Alcance máximo de água/detritos (m)</label>
                  <Field
                    name="tip_galg_cost_alcance_max"
                    component={Input}
                    maxLength={25}
                    type={'number'} 
                    onKeyDown={(evt: any) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                    disabled={viewMode}
                  />
                </div>
              </div>
              :
              <div className={clsx(styles.subitem, styles.subPontosDetalhes)}> 
                <div className={styles.spacingPontos}>
                  <Field
                    name="tip_galg_cost_alcance_max"
                    label="Alcance máximo de água/detritos (m)"
                    component={Input}
                    maxLength={25}
                    type={'number'} 
                    onKeyDown={(evt: any) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                    disabled={viewMode}
                  />
                </div>
              </div>
            ) : null}
          </div>
          <div className={styles.outrosPontosDetalhes}>
            {isMobile ?
            <><label>Danos em estruturas de proteção/defesa costeira</label><Field
                name="protecaoDefesa"
                component={Checkbox}
                onChange={onCheckboxChangeProtecao}
                disabled={viewMode} /></>
            :
                <Field
                name="protecaoDefesa"
                label="Danos em estruturas de proteção/defesa costeira"
                component={Checkbox}
                onChange={onCheckboxChangeProtecao}
                disabled={viewMode}
                
              />
            }
            
            {formRenderProps?.valueGetter("protecaoDefesa") ? (
              <div className={clsx(styles.subitem, styles.subPontosDetalhes)}>
                <div className={styles.spacingPontos}>
                  <Field
                    name="estruturaAderente"
                    label="Estrutura aderente"
                    component={Checkbox}
                    disabled={viewMode}
                  />
                </div>

                <div className={styles.spacingPontos}>
                  <Field
                    name="esporao"
                    label="Esporão/Quebra-Mar"
                    component={Checkbox}
                    disabled={viewMode}
                  />
                </div>

                <div className={styles.spacingPontos}>
                  {isMobile ? 
                  <><label>Estrutura de proteção/estabilização de arriba</label><Field
                      name="protecaoEstabilizacao"
                      component={Checkbox}
                      disabled={viewMode} /></> 
                  : <Field
                  name="protecaoEstabilizacao"
                  label="Estrutura de proteção/estabilização de arriba"
                  component={Checkbox}
                  disabled={viewMode}
                />}
                </div>
              </div>
            ) : null}
          </div>

          {tipologiaValidator && !viewMode ? (
            <div className={styles.outrosPontosDetalhes}>
              <span className='customErrorText'>
                É obrigatório selecionar pelos menos uma das caixas de seleção
              </span>
            </div>
          ) : ''}
        </div>
      </fieldset>

      <fieldset>
        <legend>
          <span className={styles.fieldsetTitulo}>Consequência(s) da ocorrência</span>
        </legend>

        <div className={styles.espacoVerticalFieldSet}>
          <div style={{ marginTop: 24 }}>
            <div className={styles.fieldsetSubTitulo}>
              Pessoas em risco
            </div>

            <div className={styles.firstPontosDetalhes}>
              <Field
                id={'pessoaEmRisco'}
                name={'pessoaEmRisco'}
                layout={'horizontal'}
                component={RadioGroup}
                disabled={viewMode}
                onChange={handlePessoaEmRiscoChange} 

                data={[
                  { label: 'Não', value: NAO },
                  { label: 'Não sabe / Não aplicável', value: NAO_SABE },
                  { label: 'Sim', value: SIM },
                ]}
                defaultValue={NAO} 
              />
            </div>
            {pessoaEmRisco == 1 || selectedOcorrenciaResult?.pessoaEmRisco == 1 ? (
            <div className={styles.numPessoasEmRisco}>
              <Field
                id={'numPessoasEmRisco'}
                name={'numPessoasEmRisco'}
                layout={'horizontal'}
                component={RadioGroup}
                disabled={viewMode}
                data={[
                  { label: '1-10', value: UMATEDEZ },
                  { label: '10-100', value: DEZATECEM},
                  { label: '>100', value: MAIORQUECEM },
                ]}
              />
            </div>
          ) : ''}

          </div>

          <div style={{ marginTop: 24 }}>
            <div className={styles.fieldsetSubTitulo}>
            Danos em edificações
            </div>
        
            <div className={styles.firstPontosDetalhes}>
            <Field
              id="danosEdificacoesOption"
              name="danosEdificacoesOption"
              layout="horizontal"
              component={RadioGroup}
              disabled={viewMode}
              onChange={(e) => {
                handleDanosChange(e);
                if (e.value === NAO) {
                  formRenderProps?.onChange("fruicaoUsoPublico",  { value : 0 });
                  formRenderProps?.onChange("danosEdificacoes",  { value: 0 });
                  formRenderProps?.onChange("outrosDanos",  { value: 0 });
                }
              }}              data={[
                { label: 'Não', value: NAO },
                { label: 'Não sabe / Não aplicável', value: NAO_SABE},
                { label: 'Sim', value: SIM },
              ]}
              defaultValue={NAO} 
            />
          </div>

          {formRenderProps?.valueGetter("danosEdificacoesOption") == SIM ? (
            <div style={{ marginTop: 24 }}>
              <div>
                <div
                  className={styles.firstPontosDetalhes}
                  title="Danos em áreas construídas de fruição/uso público (e.g. passeio pedonal/passadiços/miradouro/zonas de estadia)"
                >
                  <Field
                    name="fruicaoUsoPublico"
                    label="Danos em áreas construídas de fruição/uso público"
                    component={Checkbox}
                    disabled={viewMode}
                  />
                </div>

                <div
                  className={styles.outrosPontosDetalhes}
                  title="Danos em Edificações (e.g. habitações/comerciais/apoios de praia)"
                >
                  <Field
                    name="danosEdificacoes"
                    label="Danos em Edifícios"
                    component={Checkbox}
                    disabled={viewMode}
                  />
                </div>

                <div className={styles.outrosPontosDetalhes}>
                  <Field
                    name="outrosDanos"
                    label="Outros Danos"
                    component={Checkbox}
                    disabled={viewMode}
                  />
                  {formRenderProps?.valueGetter('outrosDanos') ? (
                    <div className={styles.subPontosDetalhes}>
                      <div className={styles.spacingPontos}>
                        <Field
                          name="outrosDanosDescricao"
                          label="Descrição"
                          placeholder="Descrição"
                          component={TextArea}
                          className={styles.defaultTextArea}
                          maxLength={528}
                          style={{ opacity: viewMode ? '0.7' : '1' }}
                          onKeyDown={keyPressTextArea}
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
             ) : null}

              </div>

          <div style={{ marginTop: 24 }}>
            <div className={styles.fieldsetSubTitulo}>
              Danos em Sistemas Naturais
            </div>

            <div style={{ marginLeft: '12px' }}>
              <Field
                id={'sistemasNaturais'}
                name={'sistemasNaturais'}
                layout={'horizontal'}
                component={RadioGroup}

                data={[
                  { label: 'Não', value: NAO },
                  { label: 'Não sabe / Não aplicável', value: NAO_SABE },
                  { label: 'Sim', value: SIM },
                ]}
                defaultValue={NAO} // Set the default
                disabled={viewMode}
              />
              {formRenderProps?.valueGetter("sistemasNaturais") == SIM ? (
                <div className={styles.spacingPontos}>
                  <Field
                    name="descricaoDanosSistemasNaturais"
                    label="Descrição"
                    placeholder="Descrição"
                    component={TextArea}
                    className={styles.defaultTextArea}
                    maxLength={528}
                    style={{opacity: viewMode ? '0.7' : '1'}}
                    onKeyDown={keyPressTextArea}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset>
        <legend>
          <span className={styles.fieldsetTitulo}>Causa(s) da Ocorrência</span>
        </legend>

        <div className={styles.espacoVerticalFieldSet}>
            <div className={styles.firstPontosDetalhes}>
              <Field
                name="naoSabe"
                label="Não sabe / Não aplicável"
                component={Checkbox}
                disabled={viewMode}
              />
            </div>

            <div className={styles.outrosPontosDetalhes}>
              <Field
                name="tempestade"
                label="Tempestade"
                disabled={viewMode}
                component={Checkbox}
              />
              {formRenderProps?.valueGetter("tempestade") ? (
                <div className={styles.subPontosDetalhes}>
                  <div className={styles.spacingPontos}>
                    <Field
                      name="descricaoTempestade"
                      label="Descrição"
                      component={TextArea}
                      className={styles.defaultTextArea}
                      maxLength={528}
                      style={{opacity: viewMode ? '0.7' : '1'}}
                      onKeyDown={keyPressTextArea}
                    />
                  </div>
                </div>
              ) : null}
            </div>
          
            <div className={styles.outrosPontosDetalhes}>
              <Field
                name="sismos"
                label="Sismos"
                component={Checkbox}
                disabled={viewMode}      
              />
            </div>

            <div className={styles.outrosPontosDetalhes}>
              <Field
                name="outras"
                label="Outras"
                component={Checkbox}
                disabled={viewMode}      
              />
              {formRenderProps?.valueGetter("outras") ? (
                <div className={styles.subPontosDetalhes}>
                  <div className={styles.spacingPontos}>
                    <Field
                      name="descricaoOutras"
                      label="Descrição"
                      placeholder="Descrição"
                      component={TextArea}
                      className={styles.defaultTextArea}
                      maxLength={528}
                      style={{opacity: viewMode ? '0.7' : '1'}}
                      onKeyDown={keyPressTextArea}
                    />
                  </div>
                </div>
              ) : null}
            </div>
        </div>
      </fieldset>

      <fieldset>
        <legend>
          <span className={styles.fieldsetTitulo}>Medidas de Mitigação do Risco</span>
        </legend>

        <div className={styles.espacoVerticalFieldSet}>
          <div style={{ marginLeft: '12px' }}>
          <Field
            id={'medidasMetigacao'}
            name={'medidasMetigacao'}
            layout={'horizontal'}
            component={RadioGroup}
            data={[
              { label: 'Não', value: NAO },
              { label: 'Não sabe / Não aplicável', value: NAO_SABE },
              { label: 'Sim', value: SIM },
            ]}
            defaultValue={NAO} // Set the default
            disabled={viewMode}
            onChange={(e) => {
              if (e.value == 0) {
                formRenderProps?.onChange('sinalizacao', { value: null });
                formRenderProps?.onChange("delimitacao",  { value: null });
                formRenderProps?.onChange("saneamento",  { value: null });
                formRenderProps?.onChange("reabilitacao",  { value: null });
                formRenderProps?.onChange("reforco",  { value: null });
              }
            }}
            />
            {formRenderProps?.valueGetter("medidasMetigacao") == SIM ? (
              <table className={styles.medidasMetigacao} cellPadding="10">
                <tr>
                  <th></th>
                  <th>Imediata</th>
                  <th>A adotar</th>
                </tr>

                <tr className={styles.item}>
                  <td>Sinalização (aviso/interdição)</td>
                  <td className={styles.alignRadio}>
                    <Field
                      id={'sinalizacao'}
                      name="sinalizacao"
                      layout={'horizontal'}
                      component={RadioGroup}
                      data={[
                        { value: ADOTADA }
                      ]}
                      disabled={viewMode}
                    />
                  </td>

                  <td className={styles.alignRadio}>
                    <Field
                      id={'sinalizacao'}
                      name="sinalizacao"
                      layout={'horizontal'}
                      component={RadioGroup}
                      data={[
                        { value: POR_ADOTAR }
                      ]}
                      disabled={viewMode}
                    />
                  </td>
                </tr>

                <tr className={styles.item}>
                  <td>Delimitação / Interdição da área de risco</td>
                  <td className={styles.alignRadio}>
                    <Field
                      name="delimitacao"
                      id={'delimitacao'}
                      layout={'horizontal'}
                      component={RadioGroup}
                      data={[
                        { value: ADOTADA }
                      ]}
                       disabled={viewMode}
                    />
                  </td>

                  <td className={styles.alignRadio}>
                    <Field
                      name="delimitacao"
                      id={'delimitacao'}
                      layout={'horizontal'}
                      component={RadioGroup}
                      data={[
                        { value: POR_ADOTAR}
                      ]}
                      disabled={viewMode}
                    />
                  </td>
                </tr>

                <tr className={styles.item}>
                  <td>Saneamento de blocos / Reperfilamento</td>
                  <td className={styles.alignRadio}>
                    <Field
                      name="saneamento"
                      id={'saneamento'}
                      layout={'horizontal'}
                      component={RadioGroup}
                      data={[
                        { value: ADOTADA }
                      ]}
                      disabled={viewMode}
                    />
                  </td>

                  <td className={styles.alignRadio}>
                    <Field
                      name="saneamento"
                      id={'saneamento'}
                      layout={'horizontal'}
                      component={RadioGroup}
                      data={[
                        { value: POR_ADOTAR }
                      ]}
                      disabled={viewMode}
                    />
                  </td>
                </tr>

                <tr className={styles.item}>
                  <td>Reabilitação de obra de proteção/estabilização</td>
                  <td className={styles.alignRadio}>
                    <Field
                      name="reabilitacao"
                      id={'reabilitacao'}
                      layout={'horizontal'}
                      component={RadioGroup}
                      data={[
                        { value: ADOTADA }
                      ]}
                      disabled={viewMode}
                    />
                  </td>

                  <td className={styles.alignRadio}>
                    <Field
                      name="reabilitacao"
                      id={'reabilitacao'}
                      layout={'horizontal'}
                      component={RadioGroup}
                      data={[
                        { value: POR_ADOTAR }
                      ]}
                      disabled={viewMode}
                    />
                  </td>
                </tr>

                <tr className={styles.item}>
                  <td>Reforço/Alimentação artificial de emergência</td>
                  <td className={styles.alignRadio}>
                    <Field
                      name="reforco"
                      id={'reforco'}
                      layout={'horizontal'}
                      component={RadioGroup}
                      data={[
                        { value: ADOTADA }
                      ]}
                      disabled={viewMode}
                    />
                  </td>

                  <td className={styles.alignRadio}>
                    <Field
                      name="reforco"
                      id={'reforco'}
                      layout={'horizontal'}
                      component={RadioGroup}
                      data={[
                        { value: POR_ADOTAR }
                      ]}
                      disabled={viewMode}
                    />
                  </td>
                </tr>
              </table>
            ) : null}
          </div>
        </div>
      </fieldset>

      <fieldset>
        <legend>
          <span className={styles.fieldsetTitulo}>Observações</span>
        </legend>

        <div className={styles.espacoVerticalFieldSet}>
          <div style={{ marginLeft: '12px' }}>
            <Field
              name="observacao"
              label="Observação"
              placeholder="Observações gerais"
              component={TextArea}
              className={styles.defaultTextArea}
              maxLength={528}
              style={{opacity: viewMode ? '0.7' : '1'}}
              onKeyDown={keyPressTextArea}
            />
          </div>
        </div>
      </fieldset>
    </div>
  )
}
